<div class="dialog-content">
  <div class="content-wrapper">
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <h2 style="margin: 0;">Import price list</h2>
      <mat-icon class="cursor" *ngIf="!loading" (click)="close()">close</mat-icon>
    </div>

    <p style="margin-top: 8px;">
      Upload a CSV with the columns
      <strong>Šifra</strong>, <strong>Bar Kod</strong>, <strong>Naziv</strong>,
      <strong>JM</strong>, <strong>MPC</strong>.
      <br />
      <span class="hint">
        Naziv and MPC are required. If you are exporting from Excel, choose
        “CSV UTF-8”.
      </span>
    </p>
    <a [href]="csvTemplateUrl" target="_blank" class="download-template">CSV Template</a>

    <mat-checkbox
      class="replace-checkbox"
      [(ngModel)]="replaceExisting"
      [disabled]="loading"
    >
      Replace the existing price list
    </mat-checkbox>
    <p class="hint" style="margin: 0;">
      <ng-container *ngIf="replaceExisting">
        All current price list items will be deleted before the new ones are added.
      </ng-container>
      <ng-container *ngIf="!replaceExisting">
        The uploaded rows will be added to the existing price list, which may
        create duplicates.
      </ng-container>
    </p>

    <app-uploader
      *ngIf="!loading"
      [hasError]="hasError"
      (onFileDropChange)="getPresignedUrl($event)"
    ></app-uploader>

    <div class="progress-wrapper" *ngIf="loading || importFinished">
      <div class="progress-track">
        <div class="progress-fill" [style.width.%]="progressPercent"></div>
      </div>
      <p class="progress-text">
        {{ statusText }}
        <span *ngIf="totalRows"> ({{ progressPercent }}%)</span>
      </p>
      <p class="hint" *ngIf="loading">
        Large price lists are imported in batches — please keep this window open.
      </p>
      <p class="hint error-hint" *ngIf="failedRows > 0">
        {{ failedRows }} row(s) could not be saved.
      </p>
    </div>

    <p class="progress-text error-hint" *ngIf="hasError && !loading && statusText">
      {{ statusText }}
    </p>
  </div>

  <div class="action-button">
    <button
      type="button"
      [promiseBtn]="loading || uploading"
      [class.active]="fileUrl && !hasError && !loading && !uploading"
      [disabled]="!fileUrl || hasError || loading || uploading"
      class="primary-button custom-button"
      (click)="addCsv()"
    >
      Import price list
    </button>
  </div>
</div>
